import React from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Colors, Text} from '@optimaxdev/design-system';

import {useDispatch} from 'react-redux';

import {SelectRxMethodButton} from 'components/success/contacts/selectRxMethodButton/selectRxMethodButton';
import {TYP_CONTACT_LENSES} from 'constants/analytics/events/typ';
import {CL_RX_METHOD, PRESCRIPTION_STATUS_LABELS} from 'constants/success';

import {getPopupContent, PopupContentItemType} from 'libs/success/popupContent/popupContent';

import {getTitle} from 'libs/success/prescriptionPopup/prescriptionPopup';

import {setDrawerMethod} from '../../../store/reducers/drawerPopup/drawerPopup';

import {ScreenWrapper} from '../screenWrapper/screenWrapper';

import {useDrawerScreenSideEffects} from './useDrawerScreenSideEffects';

import s from './defaultDrawerScreen.scss';

/**
 * Returns the default screen when you open the drawer on TYP
 */
export const DefaultDrawerScreen = () => {
    const dispatch = useDispatch();
    const {isAnyExamExist, isVista, item, shouldShowEyeExam, type} = useDrawerScreenSideEffects();

    const setMethod = (method: PopupContentItemType) => {
        const title = typeof method.title === 'string' ? method.title : method.analyticsLabel;
        sendDesktopAnalyticsEvent(
            TYP_CONTACT_LENSES,
            `${PRESCRIPTION_STATUS_LABELS[item?.prescription?.send_by || '']} - Confirmation Options - ${title}`,
        );
        dispatch(
            setDrawerMethod({
                rxMethod: method.methodName,
                title: getTitle(method.methodName, type),
            }),
        );
    };

    return (
        <ScreenWrapper>
            {shouldShowEyeExam && (
                <Text
                    as="p"
                    color={Colors.limedSpruce}
                    lineHeight="24px"
                    margin="0 0 16px 0"
                    size="16px"
                >
                    Choose one of the following options:
                </Text>
            )}
            <ul className={s.list}>
                {getPopupContent(item, isVista).map(method => {
                    const isEyeExamMethod = method.methodName === CL_RX_METHOD.EYE_EXAM;
                    const isButtonShown =
                        !isEyeExamMethod || (shouldShowEyeExam && !isAnyExamExist);
                    return (
                        isButtonShown && (
                            <li key={method.methodName}>
                                <SelectRxMethodButton
                                    badge={method.badge}
                                    description={method.description}
                                    image={method.image}
                                    isLinkButton={method.isLinkButton}
                                    name={method.methodName}
                                    onClick={() => setMethod(method)}
                                    title={method.title}
                                />
                            </li>
                        )
                    );
                })}
            </ul>
        </ScreenWrapper>
    );
};
